import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

const iconMap: Record<string, string> = {
  tv: "ri-tv-2-line",
  movie: "ri-film-line",
  anime: "ri-magic-line",
};

const accentMap: Record<string, string> = {
  tv: "bg-primary-100 text-primary-700",
  movie: "bg-accent-100 text-accent-700",
  anime: "bg-secondary-100 text-secondary-700",
};

export default function CategoryEntries() {
  return (
    <section className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span
              className={`w-14 h-14 flex items-center justify-center rounded-lg text-2xl ${accentMap[cat.key]}`}
            >
              <i className={iconMap[cat.key]} />
            </span>
            <div className="min-w-0">
              <h3 className={`text-base font-bold text-foreground-900 group-hover:text-primary-700 transition-colors`}>
                {cat.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 truncate">{cat.description}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all" />
          </Link>
        ))}
      </div>
    </section>
  );
}